import { useState } from 'react';
import { FilterPicker, RadioButtonWithLabel } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
const RadioFilterPicker = _ref => {
  let {
    title,
    testId,
    defaultLabel,
    selectedValue,
    removable,
    options,
    onApply: _onApply,
    setValue,
    onRemove,
    startOpen
  } = _ref;
  const [label, setLabel] = useState(defaultLabel);
  return /*#__PURE__*/_jsx(FilterPicker, {
    "data-testid": testId,
    label: label,
    title: title || label,
    highlightTrigger: false,
    onApply: () => _onApply(selectedValue),
    onClose: () => {},
    onRemove: onRemove,
    removable: removable,
    startOpen: startOpen,
    children: options.map(_ref2 => {
      let {
        value,
        label: optionLabel
      } = _ref2;
      return /*#__PURE__*/_jsx(RadioButtonWithLabel, {
        label: optionLabel,
        testId: "".concat(testId, "-option-").concat(value),
        checked: value === selectedValue,
        onChange: () => {
          setValue(value);
          setLabel(optionLabel);
        }
      }, value);
    })
  });
};
export default RadioFilterPicker;